import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import { Col, Form } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import OrderSourceTypeGroup from "./orderSourceTypeGroup";
import React from "react";

const SalesPointOrderSection: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  const order = vm.item.chargeOrderDetail;

  return (
    <>
      <OrderSourceTypeGroup vm={vm} />
      <Form.Group as={Col} md={6} xl={6}>
        <Form.Label>{vm.translateSubAttribute("distributorOrderDetailResponse", "forceUsed")}</Form.Label>
        <FakeInput
          target={order.distributorOrderDetail}
          property="forceUsed"
          valueFormatter={value => (value ? vm.translateGeneral("boolean.true") : vm.translateGeneral("boolean.false"))}
        />
      </Form.Group>
      <Form.Group as={Col} md={12}>
        <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "distributorOrderDetail")}</Form.Label>
        <FakeInput
          target={order}
          property="distributorOrderDetail"
          valueFormatter={value => `${value.consortiumMemberName}, ${value.salespointName} - ${value.salespointAddress}`}
        />
      </Form.Group>
    </>
  );
});

export default SalesPointOrderSection;
